"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrailingZeroDisplay = void 0;
/**
 * Enum used to control how the price format display the trailing zeros.
 */
var TrailingZeroDisplay;
(function (TrailingZeroDisplay) {
    /**
      * Display according to the settings for minimum fraction and significant digits.
      */
    TrailingZeroDisplay["AUTO"] = "AUTO";
    /**
     * Same as AUTO, but hide trailing zeros after the decimal separator if they are all zero.
     */
    TrailingZeroDisplay["HIDE_IF_WHOLE"] = "HIDE_IF_WHOLE";
})(TrailingZeroDisplay = exports.TrailingZeroDisplay || (exports.TrailingZeroDisplay = {}));
//# sourceMappingURL=trailing-zero-display.enum.js.map